import { Injectable } from '@angular/core';
import { AbstractControlOptions, FormArray } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PledgeProductRead } from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option) {
    let options: AbstractControlOptions = {};
    const totalInvoice = option.totalInvoice;
    const monthlyInvoice = option.monthlyInvoice;
    const choices = option.choices;
    const schedulePayment = option.schedulePayment;
    const remainderPayment = option.remainderPayment;
    const totalTva = option.totalTva;

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        paymentFrequency: [
          entity?.parameters?.paymentFrequency || 'ANNUALLY_PAYMENT',
        ],
        totalInvoice: [totalInvoice || entity?.parameters?.totalInvoice],
        monthlyInvoice: [entity?.parameters?.monthlyInvoice || monthlyInvoice],
        choices: [choices || entity?.parameters?.choices],
        schedulePayment: [
          schedulePayment || entity?.parameters?.schedulePayment,
        ],
        remainderPayment: [
          remainderPayment || entity?.parameters?.remainderPayment,
        ],
        totalTva: [totalTva || entity?.parameters?.totalTva],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as FormArray;
  }

  extract(): any[] {
    return _.cloneDeep(this.form?.value?.products);
  }
}
